import { useState, useEffect } from 'react';

/**
 * Returns current viewport width, updates on resize.
 * Breakpoints:
 *  mobile  < 768
 *  tablet  768–1199
 *  desktop >= 1200
 */
export function useWindowSize() {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 390
  );

  useEffect(() => {
    const handle = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handle, { passive: true });
    return () => window.removeEventListener('resize', handle);
  }, []);

  return {
    width,
    isMobile:  width < 768,
    isTablet:  width >= 768 && width < 1200,
    isDesktop: width >= 1200,
  };
}
